import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { getCommercialTechData } from './commercialThunks';
import { clearCommercialKey } from '../../sell/sellKeys';
const SLICE_NAME = 'techData';

export const techDataSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearCommercialTechData(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getCommercialTechData }).addCase(
            clearCommercialKey,
            () => commonInitialState,
        );
    },
});

export const { clearCommercialTechData } = techDataSlice.actions;

export const selectCommercialTechDataLoading = (state) =>
    state.commercialData.techData.isLoading;

export const techData = techDataSlice.reducer;
